import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["challenge", "selectedActivity"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as A from 'fp-ts/Array';
import { constVoid, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { match, P } from 'ts-pattern';
import { addActivityIdToUrl, removeCPSearchParam } from '../challenge-player-url-helpers';
import { getCurrentActivity } from './get-current-activity';
export var findActivityById = function findActivityById(activityId, activities) {
  return pipe(activities, O.fromNullable, O.chain(A.findFirst(function (a) {
    return a.id === activityId;
  })));
};

var setToLatestAvailableActivity = function setToLatestAvailableActivity(_ref) {
  var startNewActivity = _ref.startNewActivity,
      continueActivity = _ref.continueActivity,
      closeActivity = _ref.closeActivity,
      challenge = _ref.challenge;
  return match(getCurrentActivity(challenge))["with"]({
    _tag: 'cannot-start'
  }, function () {
    closeActivity();
    return undefined;
  })["with"]({
    _tag: 'can-start'
  }, function () {
    if (challenge.availableForCompletion) startNewActivity(challenge.firstStage);
    return 'new';
  })["with"]({
    _tag: 'can-continue',
    activity: P.select()
  }, function (a) {
    continueActivity(a);
    return a.id;
  }).exhaustive();
};

var setToSelectedActivity = function setToSelectedActivity(_ref2) {
  var selectedActivity = _ref2.selectedActivity,
      challenge = _ref2.challenge,
      startNewActivity = _ref2.startNewActivity,
      continueActivity = _ref2.continueActivity,
      closeActivity = _ref2.closeActivity;

  if (selectedActivity === 'new') {
    startNewActivity(challenge.firstStage);
  } else {
    pipe(findActivityById(selectedActivity, challenge.activities), O.match(closeActivity, continueActivity));
  }

  return selectedActivity;
};

export var setInitialActivity = function setInitialActivity(_ref3) {
  var challenge = _ref3.challenge,
      selectedActivity = _ref3.selectedActivity,
      setActivityProps = _objectWithoutProperties(_ref3, _excluded);

  return pipe(selectedActivity, O.fromNullable, O.map(function (a) {
    return setToSelectedActivity(_objectSpread(_objectSpread({}, setActivityProps), {}, {
      selectedActivity: a,
      challenge: challenge
    }));
  }), O.alt(function () {
    return O.fromNullable(setToLatestAvailableActivity(_objectSpread(_objectSpread({}, setActivityProps), {}, {
      challenge: challenge
    })));
  }), O.match(constVoid, function (activityId) {
    return activityId === 'new' ? removeCPSearchParam('activity') : addActivityIdToUrl(activityId);
  }));
};